var _g, _path, _g2, _path2, _rect, _rect2, _rect3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccentButtonStripesWide(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 82,
    viewBox: "0 0 280 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddd_2527_11337)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 10,
    width: 240,
    height: 32,
    rx: 16,
    fill: "#FFC619"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2527_11337",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 93,
    y: 10,
    width: 94,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.4143 16.4C93.4143 12.8654 101.742 10 112.014 10H167.814C178.087 10 186.414 12.8654 186.414 16.4V35.6C186.414 39.1346 178.087 42 167.814 42H112.014C101.742 42 93.4143 39.1346 93.4143 35.6V16.4Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2527_11337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.6492 83.3152L144.82 9.72461H133.986L79.815 83.3152H90.6492Z",
    fill: "#EEF5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.486 83.3152L169.657 9.72461H158.823L104.652 83.3152H115.486Z",
    fill: "#EEF5FC"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M161.994 18.9971C160.615 18.6875 156.595 17.8739 152.994 18.0166C148.565 18.1922 144.596 19.0253 142.689 19.5513C141.658 19.9241 140.043 19.8585 140.043 19.8585H139.86C139.86 19.8585 138.245 19.9241 137.214 19.5513C135.307 19.025 131.338 18.1919 126.908 18.0166C123.308 17.8739 119.287 18.6878 117.909 18.9971C117.618 19.0624 117.414 19.3192 117.414 19.6173V21.6644C117.414 21.9244 117.573 22.1582 117.814 22.2549L117.879 22.2811C118.064 22.3551 118.193 22.5216 118.216 22.7195C118.383 24.1962 119.185 30.3925 121.054 32.0504C123.181 33.9362 126.183 33.9118 127.939 33.9362C129.696 33.9603 134.559 34.8782 138.123 24.6865C138.188 24.5009 138.239 24.3078 138.29 24.118C138.394 23.7316 138.711 22.9505 139.582 22.8845H140.321C141.192 22.9501 141.509 23.7312 141.613 24.118C141.664 24.3078 141.715 24.5009 141.78 24.6865C145.344 34.8779 150.207 33.9603 151.964 33.9362C153.721 33.9121 156.721 33.9362 158.848 32.0504C160.718 30.3932 161.52 24.1966 161.687 22.7195C161.71 22.5216 161.839 22.3551 162.024 22.2811L162.089 22.2549C162.33 22.1582 162.489 21.9244 162.489 21.6644V19.6173C162.488 19.3192 162.284 19.0624 161.993 18.9971H161.994ZM121.544 29.9819C121.371 29.6957 121.227 29.3879 121.118 29.0615C120.872 28.3279 120.597 27.4169 120.386 26.4679L125.404 19.5551C125.981 19.5013 126.521 19.4828 126.973 19.4828C127.75 19.4828 128.27 19.5338 128.286 19.5355L128.293 19.5359C128.565 19.5561 128.825 19.5792 129.079 19.604L121.544 29.9819ZM145.959 29.9261C145.435 28.9942 144.994 27.8382 144.653 26.6146L149.646 19.7366C150.233 19.658 150.87 19.5875 151.576 19.5348L151.583 19.5345C151.6 19.5327 152.119 19.4818 152.896 19.4818C153.093 19.4818 153.307 19.4853 153.533 19.4936L145.959 29.9261Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    filter: "url(#filter1_dd_2527_11337)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 10,
    width: 240,
    height: 32,
    rx: 16,
    fill: "url(#paint0_linear_2527_11337)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 11,
    width: 238,
    height: 30,
    rx: 15,
    stroke: "#BAA35E",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 11,
    width: 238,
    height: 30,
    rx: 15,
    stroke: "#FFC619",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_2527_11337",
    x: 10,
    y: 0,
    width: 260,
    height: 62,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2527_11337"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.776471 0 0 0 0 0.0980392 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2527_11337",
    result: "effect2_dropShadow_2527_11337"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.727 0 0 0 0 0.475 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_2527_11337",
    result: "effect3_dropShadow_2527_11337"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_2527_11337",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_2527_11337",
    x: 0,
    y: 10,
    width: 280,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2527_11337"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.776471 0 0 0 0 0.0980392 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2527_11337",
    result: "effect2_dropShadow_2527_11337"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2527_11337",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2527_11337",
    x1: 140,
    y1: 10,
    x2: 140,
    y2: 42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC619"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccentButtonStripesWide);
export default __webpack_public_path__ + "static/media/accent-button-stripes_wide.08881adc1e8f097343e791cc36070622.svg";
export { ForwardRef as ReactComponent };